import React, { Suspense } from "react";
import Wrapper from "../Layouts/Wrapper";
// import { Col, Container, Row } from "react-bootstrap";
// import PipelineItem from "./PipelineItem";
const PipelineItem = React.lazy(() => import('./PipelineItem'));


const PipelinesList = (props) => {
  // console.log("props.runningOnly", props.runningOnly);
  // console.log('List props:', props);
  let pipelines = props.pipelines;
  // if (props.filterBySource !== '') {
  //   pipelines = props.pipelines.filter((pipeline) => pipeline.source === props.filterBySource);
  // }

  // const pipelines = props.pipelines.filter((pipeline) => props.filterBySource !== '' && pipeline.source === props.filterBySource);
  // const pipelines = props.runningOnly ? props.pipelines.filter((pipeline) => pipeline.status === 'running') : props.pipelines;
  
  // const showSource = (props.scheduleOnly && !props.webOnly)
  //   ? 'schedule'
  //   : (!props.scheduleOnly && props.webOnly)
  //     ? 'web'
  //     : '';

  return (
    <Wrapper className="pipelines-list">
      {pipelines.length > 0
        ? pipelines.map((pipeline) => (
        <Suspense key={pipeline.iid} >
          {/* <OtherComponent />
          </Suspense> */}
          <PipelineItem
            branch={pipeline.ref}
            ci_group={pipeline.CI_GROUP}
            details={pipeline.details}
            // duration={pipeline.duration}
            fe_url={pipeline.MICRO_URL_FRONTEND_COMMERCEOS}
            created={pipeline.created_at}
            id={pipeline.iid}
            jobs={pipeline.jobs ?? ''}
            name={pipeline.id}
            project_id={pipeline.project_id}
            qa_pipeline={pipeline.qa_pipeline ?? ''}
            sha={pipeline.sha}
            source={pipeline.source}
            status={pipeline.status}
            statusColor={
              (pipeline.status) === 'success' ? 'success' :
                (pipeline.status) === 'running' ? 'primary' :
                (pipeline.status) === 'canceled' ? 'warning' :
                (pipeline.status) === 'pending' || (pipeline.status) === 'pending' ? 'dark' :
                'danger'
            }
            updated={pipeline.updated_at}
            web_url={pipeline.web_url}
          />
        </Suspense>
        ))
        // : <p>Found no pipelines.</p>
        : <p>Found no {`${(props.runningOnly) ? 'running pipelines. Try to disable some filter.' : 'pipelines. Click "Update".'}`}</p>
      }
    </Wrapper>
  );
};

export default PipelinesList;
